/**
 * A value that lags behind its source until the changes stop.
 *
 * Type-ahead fields are the reason this exists: a query fired per keystroke is
 * eight requests to spell "Anderson", of which seven are already stale by the
 * time they land. Holding the value for a beat collapses those into one.
 *
 * The timer is reset on every change and cleared on unmount, so a component
 * that disappears mid-word never wakes up to set state on nothing.
 */

import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
